import { queryOptions, useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import { getGarageCars } from "./get-garage-cars";

import { hasAccessToken } from "@/lib/auth";
import { getGarages } from "@/services/garages/get-garages";

import type { QueryConfig } from "@/lib/react-query";

export const getGarageMarketCarIds = async (): Promise<string[]> => {
  const garages = await getGarages();
  const ids = new Set<string>();

  await Promise.all(
    (garages.results ?? []).map(async (garage) => {
      const { results } = await getGarageCars({
        garageId: garage.identifier,
        page: 1,
        pageSize: 999999,
      });

      results.forEach((car) => {
        const taxonomyId = car.taxonomy_id?.trim();
        if (taxonomyId) {
          ids.add(taxonomyId);
        }
      });
    })
  );

  return Array.from(ids);
};

export const getGarageMarketCarIdsQueryOptions = () => {
  return queryOptions({
    queryKey: ["garage-market-car-ids"],
    queryFn: getGarageMarketCarIds,
    staleTime: 0,
  });
};

type UseGarageMarketCarIdsOptions = {
  queryConfig?: QueryConfig<typeof getGarageMarketCarIds>;
};

export const useGarageMarketCarIds = ({ queryConfig }: UseGarageMarketCarIdsOptions = {}) => {
  const { data, ...props } = useQuery({
    enabled: hasAccessToken(),
    ...getGarageMarketCarIdsQueryOptions(),
    ...queryConfig,
  });

  const marketCarIds = useMemo(() => new Set(data ?? []), [data]);

  return { marketCarIds, ...props };
};
